import { EVENT_COLOR_CLICKED } from './components/color/constants.mjs'
import { DEFAULT_MAX_COLOR_COUNT, EVENT_COLOR_CHANGE } from './constants.mjs'

import createProps from '@kissui/helpers/src/props.helpers'
import { dispatchEvent, readEvent } from '@kissui/helpers/src/assets/js/eventDispatch'

import fetcherService from '@kissui/page-builder-sections/src/cross-sell/services/fetcher.service'
import './components/color'

class Colors extends HTMLElement {
    constructor() {
        super()
        this._apiProducts = {}
        this._colors = []
        this._maxColors = DEFAULT_MAX_COLOR_COUNT
    }

    async connectedCallback() {
        this.props = createProps(this.attributes)
        this.updateMaxColors()

        await this.fetchColors()

        this.render()
        this.createEventListeners()
    }

    hasColorData() {
        return this.props.colors && this.props.colors.every(this.hasAllProps)
    }

    hasAllProps(color) {
        return color.sku != null && color.name != null && color.code != null
    }

    createEventListeners() {
        this.addEventListener(EVENT_COLOR_CLICKED, this.onColorChange)
    }

    render() {
        const { heading = '' } = this.props

        this.innerHTML = `
            ${heading ? `<p class="t-sm-400-sl">${heading}</p>` : ``}
            ${this.renderColors()}${this.renderExtraColors()}
        `
    }

    renderColors() {
        return this._colors.map(this.renderColor.bind(this)).join('')
    }

    renderColor(color) {
        const { a11y_label = '', activeSku, size = 'large' } = this.props
        const { code = '', name = '', link = '', sku = '' } = color
        this.classList.add(size)

        return `
            <nb-color
                code="${code}"
                label="${name}"
                link="${link}"
                sku="${sku}"
                selected="${sku === activeSku}"
                ${a11y_label ? `a11y_label="${a11y_label}"` : ''}
                size="${size}"
            ></nb-color>
        `
    }

    renderExtraColors() {
        const { colors = [], extra_url, extra_title } = this.props
        const extraColorsLength = Math.max(0, colors.length - this._maxColors)
        if (extraColorsLength <= 0 || !extra_url) {
            return ''
        }

        return `
            <nb-link
                size="small"
                color="black"
                seo_label="${extra_title}"
                aria-label="${extra_title}"
                link="${extra_url}"
            >+${extraColorsLength}</nb-link>`
    }

    async fetchColors() {
        if (this.hasColorData()) {
            this._colors = this.clampColor(this.props.colors)
            return
        }
        try {
            const preparedColors = this.prepareColors(this._maxColors)
            await Promise.all(preparedColors.map(this.fetchColor.bind(this)))
        } catch (error) {
            console.error(`Fetch for colors failed: ${error}`)
        }
    }

    async fetchColor(color) {
        const { prevent } = this.props
        const apiProduct = await fetcherService.getApiProduct(color.sku)
        const apiColor = {
            code: apiProduct.colorShade.cssCode,
            name: apiProduct.colorShade.name,
            link: prevent === undefined ? apiProduct.pdpURLs.desktop : ''
        }
        this._apiProducts[color.sku] = apiProduct
        this._colors.push({ ...color, ...apiColor })
    }

    prepareColors() {
        const { colors = [] } = this.props
        return this.clampColor(colors).filter(this.hasSKU)
    }

    clampColor(colors) {
        return colors.slice(0, this._maxColors)
    }

    hasSKU(colorItem) {
        return colorItem.sku != null && colorItem.sku !== ''
    }

    updateMaxColors() {
        const { max_colors } = this.props
        if (max_colors) {
            this._maxColors = parseInt(max_colors)
        }
    }

    onColorChange($event) {
        const { sku } = readEvent($event)
        const productData = { ...this._apiProducts[sku], sku }
        if (productData) {
            dispatchEvent({
                element: this,
                eventName: EVENT_COLOR_CHANGE,
                args: { productData }
            })
        }
    }
}

// Registers custom element
customElements.get('nb-colors') || customElements.define('nb-colors', Colors)

export default Colors
